import React from 'react';
import moment from 'moment';
import connect from "react-redux/es/connect/connect";
import Storage from '../../../services/Storage'
import LoadingIndicator from "../loading/LoadingIndicator";


class RefreshToken extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      refreshing:true,
      accessToken: Storage.getSessionItem('connected-token')
    }

  }
  componentDidMount(){
    if (this.shouldRenew()){
      this.props.dispatchFetchRefreshToken();
    } else {
      this.setState({refreshing: false});
    }

    setTimeout(this.renew, 1000 * 60 * 5);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.refreshing && prevState.accessToken !== Storage.getSessionItem('connected-token')){
      this.setState({refreshing:false})
    }
  }

  shouldRenew = () => {
    const tokenExpiration = Storage.getConnectedTokenExpiration();
    return tokenExpiration !== undefined && moment(tokenExpiration).isBefore(moment().utc());
  };

  renew = () => {
    if (!this.state.refreshing && this.shouldRenew()){
        this.props.dispatchFetchRefreshToken();
    }
  };

  render() {
    const {refreshing} = this.state;
    return refreshing ? <LoadingIndicator/> : this.props.children;
  }
}

const mapDispatchToProps = dispatch => { return {
  dispatchFetchRefreshToken: () => {
    return dispatch({type: 'FETCH.CUSTOMER_REFRESH_TOKEN.REQUEST'})
  },
}};

const mapStateToProps = state => ({
  authentication: state.authentication,
});

export default
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(RefreshToken);
